/**
 * withAuth
 * HOC for wrapping the provided component with AuthProvider
 */

import React from 'react'

import AuthProvider from './auth-provider'

export default function withAuth (WrappedComponent) {
  return function AuthProviderHOC(props) {
    return (
      <AuthProvider>
        <WrappedComponent {...props} />
      </AuthProvider>
    )
  }
}
